









































import BaseComponent from '@/components/base-component.vue';
import UiSelectGeoAreas from '@/components/UI/select-geo-area.vue';
import { listCrmInstitutionEvolutionMonthOptions } from '@/services/crm-institution-evolution';
import { PATIENT_TYPES_LIST } from '@/settings/consts/patient';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {
    UiSelectGeoAreas
  }
})
export default class CrmInstitutionEvolutionFilters extends BaseComponent {
  @Prop()
  public menuMode?: boolean;

  filter: any = {};
  visitors = [];

  loadingMonths = false;
  monthOptions = [];

  patientTypesList = PATIENT_TYPES_LIST;

  beforeMount() {
    this.loadMonthOptions();
  }

  loadMonthOptions() {
    this.loadingMonths = true;
    listCrmInstitutionEvolutionMonthOptions().subscribe(
      (res) => {
        this.loadingMonths = false;
        this.filter.month = res.selecionado.id;
        this.monthOptions = res.meses;
        this.emitFilter();
      },
      (error) => {
        this.loadingMonths = false;
        this.showToastApiError(error);
      }
    );
  }

  onChangeFilter() {
    if (this.menuMode) {
      return;
    }

    this.emitFilter();
  }

  mounted() {}

  emitFilter() {
    this.$emit('filter', this.filter);
  }
}
